/**
 * badgeClass.js — scheduler-domain state-to-badge-class mapping, shared by the schedules list grid
 * and the schedule detail rail (both the "state" column/field and the executions grid's "status"
 * column). Pure: no imports, no state, no React. Mirrors
 * workflow/generic/playground/session/sessionStatus.js#sessionStatusClass.
 */

// A schedule is "active" until it completes (one-time) or is exhausted (recurring past its end
// date); leaving active is an ordinary terminal state, not something that needs attention, so it
// gets the same grey/muted treatment sessionStatusClass uses for its own non-steady states.
export function scheduleStateBadgeClass(state) {
  return "active" === state ? "title-tag-badge" : "title-tag-badge-muted";
}

// A successful execution is the steady state; a failed one is the case that needs attention.
export function executionStatusBadgeClass(status) {
  return "success" === status ? "title-tag-badge" : "title-tag-badge-warning";
}
